<app-space-layout [userAvatar]="userAvatar" [userFirstName]="userFirstName" [menuItems]="menuItems" (onLogout)="logout()">
    <router-outlet></router-outlet>
</app-space-layout>